<template>
  <v-container grid-list-lg fluid>
    <v-layout row align-center>
      <v-flex shrink>
        <v-btn small rounded text @click.stop.prevent="$router.go(-1)">
          <v-icon left>mdi-chevron-left </v-icon>
          <span class="hidden-sm-and-down">Multi Store Report</span>
        </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex shrink class="title text-right">
        Location Report
      </v-flex>
    </v-layout>

    <v-layout row wrap class="mt-2">
      <v-flex xs12 md4>
        <v-select v-if="location" outlined dense :items="locations" v-model="location" @change="loadData"
          label="Select Store" hide-details return-object item-text="businessName"></v-select>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 md3>
        <DateTimePicker :defaultRange="dateTime.id" :range="true" :hideTime="true" v-model="dateTime"
          @submit="closeDatePicker" />
      </v-flex>
    </v-layout>
    <v-layout row v-if="location" align-center>
      <v-flex shrink>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium text-capitalize">{{ location.businessName }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ location.address }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-flex>
      <v-spacer></v-spacer>
      <!-- <v-flex shrink>
        <DateSelector />
      </v-flex> -->
    </v-layout>

    <!-- <div class="text-h5">{{ location.name }}</div> -->

    <v-layout column v-if="location">
      <v-flex>
        <v-layout fill-height row wrap>
          <v-scale-transition>
            <v-flex xs12 md2 class="d-flex" v-if="bestEmployee">
              <v-card width="100%" outlined dark color="blue darken-1">
                <v-layout row fill-height>
                  <v-flex>
                    <v-layout row>
                      <v-flex>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-card-text v-bind="attrs" v-on="on">
                              <div class="title">{{ nFormatter(bestEmployee.SaleAmount) }}</div>
                              <div class="caption d-inline-block text-truncate" style="max-width: 75px;">{{
                                  bestEmployee.EmployeeName
                              }}</div>
                              <div>Top Sale</div>
                            </v-card-text>
                          </template>
                          <div>
                            <div>{{ bestEmployee.SaleAmount | currency }}</div>
                            <div>{{ bestEmployee.EmployeeName }}</div>
                          </div>
                        </v-tooltip>

                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs5>
                    <v-img max-height="75px" contain src="@/assets/gold-medal.png">
                    </v-img>
                  </v-flex>
                </v-layout>


              </v-card>
            </v-flex>
          </v-scale-transition>

          <v-flex>
            <CategorySale v-if="item" :saleData="item" />
          </v-flex>

        </v-layout>
      </v-flex>
      <v-flex>

        <v-layout row wrap>
          <v-flex xs12 md4>
            <v-card outlined>
              <v-card-text>
                <div>Sale By Employee</div>

                <SaleByEmployeeChart :saleData="EmployeeSale" />
              </v-card-text>
            </v-card>

          </v-flex>
          <v-flex xs12 md8>
            <v-card outlined>
              <v-card-text>
                <div>Sale By Sub-Category</div>

                <SaleBySubCategory :saleData="saleByCategory" />
              </v-card-text>
            </v-card>

          </v-flex>

        </v-layout>
      </v-flex>
      <v-flex>
        <v-layout row wrap>
          <v-flex xs12 md8>
            <v-card outlined>
              <v-toolbar dense class="mb-3" flat color="blue lighten-4">
                <v-toolbar-title class="subtitle-1">Profit & Lose Report</v-toolbar-title>
                <v-spacer></v-spacer>
                <div :class="foreColor(profit)" class="font-weight-bold">{{ profit | currency }}</div>
              </v-toolbar>
              <v-card-text>
                <v-data-table item-key="MainCategoryName" :single-expand="singleExpand" :expanded.sync="expanded"
                  :headers="headers"  :items="PNLReport" loading-text="Loading... Please wait" sort-by="name" hide-default-footer
                  :items-per-page="PNLReport.length">
                  <template v-slot:item="{ item, isExpanded, expand }">
                    <tr class="pointer">
                      <td class="text-left small-td pointer">
                        <v-btn @click="expand(true)" icon v-if="!isExpanded">
                          <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                        <v-btn @click="expand(false)" icon v-if="isExpanded">
                          <v-icon>mdi-chevron-up</v-icon>
                        </v-btn>
                        {{ item.MainCategoryName }}
                      </td>
                      <td class="text-center small-td pointer">
                        <div>{{ parseInt(item.Quantity) }}</div>
                      </td>
                      <td class="text-right small-td pointer">
                        <div>{{ item.SaleAmount | currency }}</div>
                      </td>
                      <td class="text-right small-td pointer">
                        <div>{{ item.CostAmount | currency }}</div>
                      </td>
                      <td class="text-right small-td pointer">
                        <div>{{ item.DetailDiscount | currency }}</div>
                      </td>
                      <td :class="foreColor(item.profit)" class="font-weight-bold text-right small-td pointer">
                        <div>{{ item.profit | currency }}</div>
                      </td>

                    </tr>
                  </template>
                  <template  v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pa-0" :key="item.MainCategoryID">
                      <v-card color="blue-grey darken-4" dark>
                        <SubCategoryList :dateTime="dateTime" :location="location"
                          :mainCategory="item.MainCategoryID" />
                      </v-card>
                    </td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 md4>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card outlined @click="openRepairList">
                  <v-layout row align-center>
                    <v-flex>
                      <v-card-text>
                        Open Repair
                        <div class="caption ">Outstanding: <span class="font-weight-bold">{{ repairTotal | currency
                        }}</span>
                        </div>
                        <v-scale-transition>
                          <div v-show="showValue" class="mt-2 text-center text-h1 font-weight-thin">
                            {{ repairList.length || 0 }}
                          </div>
                        </v-scale-transition>



                      </v-card-text>
                    </v-flex>
                    <v-flex shrink>
                      <v-img contain max-width="100" src="@/assets/smartphone.png">
                      </v-img>
                    </v-flex>

                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs6>
                <v-card outlined height="100%" width="100%" class="pa-3">
                  <v-layout column align-center justify-center fill-height>
                    <v-flex>
                      <v-img contain max-width="55" src="@/assets/document.png"></v-img>
                    </v-flex>
                    <v-flex shrink>
                      <div class="text-center">
                        Tax Collected
                      </div>
                    </v-flex>
                    <v-flex shrink>
                      <div class="text-center text-h5">
                        {{ totalTax | currency }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs6>
                <v-card outlined height="100%" width="100%" class="pa-3">
                  <v-layout column align-center justify-center fill-height>
                    <v-flex>
                      <div class="text-center text-h1 font-weight-thin">
                        {{ BatchList.length }}
                      </div>
                    </v-flex>
                    <v-flex>
                      <div class="text-center">
                        Batches
                      </div>
                    </v-flex>

                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>







    <div v-else>
      <v-layout row wrap justify-center>
        <v-flex shrink>
          <v-card width="350" class="mt-5" outlined>
            <v-card-text class="text-center">
              <v-chip label>Location is not selected</v-chip>
              <div class="mt-5">Select Location</div>
              <v-select outlined dense :items="locations" v-model="location" @change="loadData" label="Select Store"
                hide-details return-object item-text="businessName"></v-select>
            </v-card-text>

          </v-card>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog
      v-model="showRepairDialog"
      transition="dialog-transition"
    >
      <v-card>
        <ModelTitle title="Open Repair" @close="showRepairDialog= !showRepairDialog" />
        <v-card-text>
          <RepairList :location="location"/>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import reportService from '@/pages/Report/service.js'
import CategorySale from '@/pages/Report/components/CategorySale.vue'
import { mapGetters } from 'vuex'
import DateTimePicker from '@/components/DateTimePicker.vue'
import SaleByEmployeeChart from '@/pages/Report/components/Charts/SaleByEmployee.vue'
import SaleBySubCategory from '@/pages/Report/components/Charts/SaleBySubCategory.vue'
import SubCategoryList from '@/pages/Report/components/SubCategoryList.vue'
import ModelTitle from '@/components/ModelTitle.vue'
import RepairList from '@/pages/Report/components/Repair/RepairList.vue'


export default {
  name: 'report-by-location',
  data: () => ({
    showRepairDialog: false,
    totalTax: 0,
    BatchList: [],
    expanded: [],
    singleExpand: true,
    profit: 0,
    headers: [
      {
        text: 'Categories',
        align: "left",
        sortable: true,
        value: "MainCategoryName"
      },
      {
        text: 'Quantity',
        value: "Quantity",
        sortable: true
      },
      {
        text: 'Sale',
        value: "address",
        sortable: true
      },
      {
        text: 'Cost of goods',
        value: "CostAmount",
        sortable: true
      },
      {
        text: 'Discount',
        value: "DetailDiscount",
        sortable: true
      },
      {
        text: 'Profit',
        align: 'right',
        value: "profit",
        sortable: true
      },
    ],
    showValue: false,
    repairList: [],
    PNLReport: [],
    repairTotal: 0,
    saleByCategory: null,
    bestEmployee: null,
    EmployeeSale: null,
    location: null,
    dateTime: {
      id: 'since7DaysAgo',
      start: null,
      end: null,
    },
    menu: false,
    item: null,
    selectedDate: null,
  }),
  components: {
    ModelTitle,
    CategorySale,
    DateTimePicker,
    SaleByEmployeeChart,
    SaleBySubCategory,
    RepairList,
    SubCategoryList,
  },
  computed: {
    ...mapGetters('location', ['locations'])
  },
  created() {
    if (this.$route.params.location) {
      this.location = this.$route.params.location
      this.item = this.$route.params.item
      this.dateTime = this.$route.params.date
    }
    this.loadData()
  },
  watch: {
    location(val) {
      if (val) {
        // console.log('location change', val.storeID)
      }
    }
  },
  methods: {
    openRepairList() {
      this.showRepairDialog = !this.showRepairDialog
      // console.log('reapir', this.location)
      // this.$router.push({ name: 'openRepair-list', params: { location: this.location } });
    },
    foreColor(val) {
      let color = 'green--text'
      if (val < 0) {
        color = 'red--text'
      }
      return color
    },
    loadData() {
      if (this.location) {
        this.profitAndLose()
        this.getSaleByEmployee()
        this.getSubCategory()
        this.getRepairList()
        this.getTax()
        this.getBatchList()
      }

    },
    async profitAndLose() {
      if (!this.location || !this.dateTime.start) return false
      // // console.log('category got call', this.locations.length)
      this.loading = true
      // let list = []
      this.PNLReport = []
      return reportService
        .profitAndLose(this.location.storeID, { from: this.dateTime.start.split("T")[0], to: this.dateTime.end.split("T")[0] })
        .then(response => {

          // console.log('pnl report', response)
          this.PNLReport = response.data
          let cost = 0,
            discount = 0,
            sale = 0

          this.PNLReport.map(row => {
            cost += parseFloat(row.CostAmount)
            sale += parseFloat(row.SaleAmount)
            discount += parseFloat(row.DetailDiscount)
            row.profit = parseFloat(row.SaleAmount) - parseFloat(row.CostAmount) - parseFloat(row.DetailDiscount)
          })

          this.profit = sale - cost - discount
          const saleData = _.groupBy(response.data, (value) => {
            // // console.log('value', value)
            return value.MainCategoryName.replace(/ /g, "")
          })
          this.item = {
            id: location.storeID,
            name: location.businessName,
            ...saleData
          }
          return response;
        }).catch(err => {
          // console.log('err', err)
        })


    },
    async getSaleByEmployee() {
      if (!this.location || !this.dateTime.start) return false
      this.loading = true
      this.EmployeeSale = null
      return reportService
        .getSaleByEmployee(this.location.storeID, { from: this.dateTime.start.split("T")[0], to: this.dateTime.end.split("T")[0] })
        .then(response => {
          // console.log('getSaleByEmployee response', response)
          this.EmployeeSale = response.data
          const maxSale = Math.max(...this.EmployeeSale.map(o => o.SaleAmount))
          this.bestEmployee = null
          this.EmployeeSale.map(row => {
            row.name = row.EmployeeName
            row.y = parseFloat(row.SaleAmount)
            if (parseFloat(row.SaleAmount) === maxSale) {
              this.bestEmployee = row
              this.bestEmployee.SaleAmount = parseFloat(row.SaleAmount)
              row.sliced = true,
                row.selected = true
            }
          })

          return response;
        }).catch(err => {
          // console.log('err', err)
        })
    },
    async getSubCategory() {
      if (!this.location || !this.dateTime.start) return false
      this.loading = true
      return reportService
        .getSubCategory(this.location.storeID, { mainCategory: 'NULL', from: this.dateTime.start.split("T")[0], to: this.dateTime.end.split("T")[0] })
        .then(response => {
          // console.log('getSubCategory response', response)
          this.saleByCategory = response.data
          return response;
        }).catch(err => {
          // console.log('err', err)
        })
    },
    async getRepairList() {
      if (!this.location || !this.dateTime.start) return false
      this.showValue = false
      return reportService
        .getRepairList(this.location.storeID)
        .then(response => {
          // console.log('getRepairList response', response)
          this.repairList = response.data
          let total = 0
          this.repairList.map(row => {
            total += parseFloat(row.RepairPrice)
          })
          this.repairTotal = total
          this.showValue = true
          // this.saleByCategory = response.data
          return response;
        }).catch(err => {
          // console.log('err', err)
        })
    },
    async getTax() {
      if (!this.location || !this.dateTime.start) return false
      return reportService
        .getTax(this.location.storeID, { from: this.dateTime.start.split("T")[0], to: this.dateTime.end.split("T")[0] })
        .then(response => {
          // console.log('getTax response', response)
          response.data.map(row => {
            this.totalTax += parseFloat(row.TaxAmount)
          })
          // this.saleByCategory = response.data
          return response;
        }).catch(err => {
          // console.log('err', err)
        })
    },
    getBatchList() {
      if (!this.location || !this.dateTime.start) return false
      return reportService
        .getBatchList(this.location.storeID, { from: this.dateTime.start.split("T")[0], to: this.dateTime.end.split("T")[0] })
        .then(response => {
          // console.log('getBatchList response', response)
          this.BatchList = response.data
          // response.data.map(row => {
          //   this.totalTax += parseFloat(row.TaxAmount)
          // })
          // this.saleByCategory = response.data
          return response;
        }).catch(err => {
          // console.log('err', err)
        })
    },
    nFormatter(num) {
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      }
      return num;
    },
    closeDatePicker() {
      this.loadData()

      // this.$refs.menu.save(this.dates)
      // // console.log('dates', this.dates)
    },
  }
}
</script>

<style scoped>
</style>